/* eslint-disable max-len */
import React from "react"
import Pagination from "../../../components/Pagination"

const InventoryTable = ({InventoryList,
    searchParams, 
    navigate,
    setPageType,
    setSubInventoryTableLoading,
    setSearchParams,  
    setPageLoading, 
    InventoryCount}) => {
        
    /**
     * The function `handleOnClickPageNumber` updates the search parameters with a new page number and sets
     * the page loading state to true.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setPageLoading(true);
        const params = Object.fromEntries(searchParams) 
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    /**
     * The function `navigateSubInvenotryHandler` is used to navigate to a sub-inventory page with specific
     * parameters and item details.
     */
    const navigateSubInvenotryHandler = async(itemCode, itemID) => {
        let params = Object.fromEntries(searchParams);
        params.type = 'sub-inventory';
        params.inv_id = itemID;
        params.page_number_sub_inventory = 1;
        setPageType('sub-inventory');
        setSubInventoryTableLoading(true);
        const searchParamsCopy = new URLSearchParams({...params});
        const encodedItemCode = encodeURIComponent(itemCode);
        await navigate(`${location.pathname}/${encodedItemCode}${
            searchParamsCopy.toString() === '' ? '' : `?${searchParamsCopy.toString()}`}`);
    };

    return(
        <div class=" w-full relative">
            <div class=" overflow-x-auto pb-2.5 scroll-bar -mx-[2px]">
                <div class={`flex px-[6px] ${InventoryCount > 50 ? 'max-h-[calc(100vh-268px)]' : 'max-h-[calc(100vh-228px)]'}`}>
                    <table aria-label="Outside Table" class="w-full relative stickyhead" id="admin-table">
                        <thead>
                            <tr>
                                <th class="sticky top-0 w-[10%]"><span></span>
                                </th>
                                <th class="sticky top-0 w-[10%]"><span></span>
                                </th>
                                <th colSpan={2} class="w-[20%]">
                                    <span class="sticky top-0 flex items-center justify-center">Opening Stock</span>
                                </th>
                                <th colSpan={2} class="w-[20%]">
                                    <span class="sticky top-0 flex items-center justify-center">Inwards</span>
                                </th>
                                <th colSpan={2} class="w-[20%]">
                                    <span class="sticky top-0 flex items-center justify-center">Outwards</span>
                                </th>
                                <th colSpan={2} class="w-[20%]">
                                    <span class="sticky top-0 flex items-center justify-center">Closing Stock</span>
                                </th>
                            </tr>
                            <tr aria-colspan="7" class="h-1"></tr>
                        </thead>
                        <tbody >
                            
                            <tr class="group">
                                <td class="text-start font-semibold ">Item Code</td>
                                <td class="text-start  font-semibold border-r border-[#C2DCEF]">Item Name</td>

                                <td class="text-end  font-semibold min-w-[65px]">Qty</td>
                                <td class="text-end  font-semibold border-r border-[#C2DCEF] min-w-[105px]">Value</td>

                                <td class="text-end  font-semibold min-w-[65px]">Qty</td>
                                <td class="text-end  font-semibold border-r border-[#C2DCEF] min-w-[105px]">Value</td>

                                <td class="text-end  font-semibold min-w-[65px]">Qty</td>
                                <td class="text-end  font-semibold border-r border-[#C2DCEF] min-w-[105px]">Value</td>

                                <td class="text-end  font-semibold min-w-[65px]">Qty</td>
                                <td class="pl-3 pr-6 py-[15px] text-f2 text-[#031624] text-end  font-semibold  min-w-[105px]">Value</td>
                            </tr>

                            {InventoryList?.map((inventory, index) => (
                                <>
                                    <tr id="list-items" aria-colspan="7" class="relative h-0.5 z-[-10]"></tr>
                                    <tr class={`group ${'cursor-pointer'}`} id={index+'item'}
                                        onClick={()=> {
                                            // if(inventory?.inward_cost_price == 0 && inventory?.outward_selling_price == 0){
                                            //     return
                                            // } else {
                                            navigateSubInvenotryHandler(inventory?.item_code, inventory?.inventory_id)
                                            // }
                                        }}
                                    >
                                        <td class="text-start">{inventory?.item_code || '-'}</td>
                                        <td class="text-start  border-r border-[#C2DCEF]">{inventory?.item_name || '-'}</td>

                                        <td class="text-end" id={'OB_Qty'+index}>{inventory?.opening_stock_quantity || '-'}</td>
                                        <td class="text-end  border-r border-[#C2DCEF]" id={'OB_Price'+index}>{parseFloat(inventory?.opening_stock_amount).toFixed(2) || '-'}</td>
                                        
                                        <td class="text-end" id={'In_Qty'+index}>{inventory?.inward_total_quantity || '-'}</td>
                                        <td class="text-end  border-r border-[#C2DCEF]" id={'In_Price'+index}>{parseFloat(inventory?.inward_cost_price).toFixed(2) || '-'}</td>

                                        <td class="text-end" id={'Out_Qty'+index}>{inventory?.outward_total_quantity || '-'}</td>
                                        <td class="text-end  border-r border-[#C2DCEF]" id={'Out_Price'+index}>{parseFloat(inventory?.outward_selling_price).toFixed(2) || '-'}</td>

                                        <td class="text-end" id={'CB_Qty'+index}>{inventory?.closing_stock_quantity || '-'}</td>
                                        <td class="text-end"  id={'CB_Price'+index}>{parseFloat(inventory?.closing_stock_amount).toFixed(2) || '-'}</td>
                                    </tr>
                                </>))}
                        </tbody>
                        
                    </table>
                </div>
            </div>
            <div className="">
                {InventoryCount > 50 && <Pagination
                    TotalCount={InventoryCount}
                    limit={50}
                    totalPageNumber={Math?.ceil(InventoryCount / 50)}
                    selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                    handleOnClickPageNumber={handleOnClickPageNumber}
                />}
            </div>
        </div>
    )
}

export default InventoryTable;